import { TableCell, TableRow } from "@/components/ui/table"

import TripDisplay from "./TripDisplay"

import type { BalanceRegionTripDays } from "../types/balanceMapTypes"

interface RegionBalanceTripsProps {
  trips: BalanceRegionTripDays
}

export default function RegionBalanceTrips({ trips }: RegionBalanceTripsProps) {
  const getMaxRows = () => {
    const todayIn = trips.today.in.length
    const todayOut = trips.today.out.length
    const tomorrowIn = trips.tomorrow.in.length
    const tomorrowOut = trips.tomorrow.out.length
    return Math.max(todayIn, todayOut, tomorrowIn, tomorrowOut)
  }
  return (
    <>
      {[...Array(getMaxRows()).keys()].map((i) => {
        const todayIn = trips.today.in.at(i)
        const todayOut = trips.today.out.at(i)
        const tomorrowIn = trips.tomorrow.in.at(i)
        const tomorrowOut = trips.tomorrow.out.at(i)

        return (
          <TableRow key={i}>
            <TableCell></TableCell>
            <TableCell className="whitespace-normal">
              {todayIn && (
                <TripDisplay
                  origin={todayIn.origin}
                  destination={todayIn.destination}
                  customer={todayIn.customer}
                  number={todayIn.number}
                />
              )}
            </TableCell>
            <TableCell className="whitespace-normal">
              {todayOut && (
                <TripDisplay
                  origin={todayOut.origin}
                  destination={todayOut.destination}
                  customer={todayOut.customer}
                  number={todayOut.number}
                />
              )}
            </TableCell>
            <TableCell className="whitespace-normal bg-gray-50">
              {tomorrowIn && (
                <TripDisplay
                  origin={tomorrowIn.origin}
                  destination={tomorrowIn.destination}
                  customer={tomorrowIn.customer}
                  number={tomorrowIn.number}
                />
              )}
            </TableCell>
            <TableCell className="whitespace-normal bg-gray-50 pr-3">
              {tomorrowOut && (
                <TripDisplay
                  origin={tomorrowOut.origin}
                  destination={tomorrowOut.destination}
                  customer={tomorrowOut.customer}
                  number={tomorrowOut.number}
                />
              )}
            </TableCell>
          </TableRow>
        )
      })}
    </>
  )
}
